var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.7754 8.07496H10.0933C10.8412 8.07496 11.2151 8.98014 10.6874 9.50787L6.52846 13.6668C6.19994 13.9953 5.66871 13.9953 5.34369 13.6668L1.18126 9.50787C0.653535 8.98014 1.02749 8.07496 1.7754 8.07496ZM10.6874 4.40532L6.52846 0.24639C6.19994 -0.0821301 5.66871 -0.0821301 5.34369 0.24639L1.18126 4.40532C0.653535 4.93305 1.02749 5.83823 1.7754 5.83823H10.0933C10.8412 5.83823 11.2151 4.93305 10.6874 4.40532Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filtericon.29e4ed924d1afe890e56a061e91987ca.svg";
export { ForwardRef as ReactComponent };